import Group from 'components/utils/Group'
import React from 'react'
import { useIntl } from 'react-intl'
import LuxPlusLogo from 'luxPlus/components/Logos/LuxPlusLogo'
import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'
import styled from 'styled-components'
import { rem } from 'polished'
import { LUXURY_PLUS_PATHS } from 'luxPlus/constants/base'
import { getThemeClassName } from 'lib/theme/themeUtils'

const LuxPlusNotificationBannerWrapper = styled(Group)`
  padding: ${rem(16)};
  background-color: ${props => props.theme.palette.product.luxPlus.background};
  color: ${props => props.theme.palette.product.luxPlus.contrast};
`

interface Props extends React.PropsWithChildren {
  hideCta?: boolean
}

function LuxPlusNotificationBanner(props: Props) {
  const { children, hideCta = false } = props
  const intl = useIntl()
  return <LuxPlusNotificationBannerWrapper
    className={getThemeClassName({ mobile: 'inverse' })}
    direction="vertical"
    tabletDirection="horizontal"
    verticalAlign="center"
    horizontalAlign="center"
    gap={4}
    tabletGap={20}
  >
    <LuxPlusLogo height={16} />
    <BodyText variant="medium" colour="neutral-one" align="center">{children}</BodyText>
    {!hideCta && <TextLink
      weight="bold"
      underline
      size="medium"
      wrap="no-wrap"
      target="_blank"
      to={`/${LUXURY_PLUS_PATHS.LANDING_PAGE}`}
    >
      {intl.formatMessage({
        id: 'y8u003h48-T-RprIi_c0',
        defaultMessage: 'Learn more',
        description: 'CTA link text on LuxPlus notification banner to learn more about membership',
      })}
    </TextLink>}
  </LuxPlusNotificationBannerWrapper>
}

export default LuxPlusNotificationBanner
